import type {FunctionComponent} from 'react';
import {useTranslation} from '@app/hooks/use-translation';
import {LandingHeading, LandingParagraph} from '@tempo/landing';
import {Image} from '@app/components/Image';
import {useIsVerboseLocale} from '@app/hooks/use-verbose-locale';
import {LandingButtonLink} from '@app/components/landing-btn-link';
import type {LocalImageConfig} from '@app/hooks/use-local-image';
import {useLocalImage} from '@app/hooks/use-local-image';
import {LandingIllustrationSection} from '@app/components/layout/LandingIllustrationSection';

const IMAGE_CONFIG: LocalImageConfig = {
	default: '2119036973d9913ab9a73912d719d3cf.png',
	fr: '3f7bbe33dd7f8a4deb63b42b89f2f5cd.png',
};

export const Live: FunctionComponent = () => {
	const {t} = useTranslation();
	const src = useLocalImage(IMAGE_CONFIG);
	const isVerboseLocale = useIsVerboseLocale();
	const fontSize = isVerboseLocale
		? {base: 'xs', sm: 'sm', xl: 'md'}
		: undefined;

	return (
		<LandingIllustrationSection
			imagePosition="right"
			description={
				<>
					<LandingHeading as="h2">
						{t('musicquizlandingpage_title_doyouliveforkpop_standalone-web', {
							ns: 'musicquiz',
						})}
					</LandingHeading>
					<LandingParagraph>
						{t('musicquizlandingpage_text_doyouliveforkpop_standalone-web', {
							ns: 'musicquiz',
						})}
					</LandingParagraph>
				</>
			}
			image={
				<Image
					sizes={{base: '100vw', md: '50vw'}}
					src={src}
					quality={90}
					aspectRatio="1440/840"
					alt={t('generic_action_playnow_standalone-web', {ns: 'common'})}
				/>
			}
			cta={
				<LandingButtonLink
					href="https://link.deezer.com/?dest=https%3A%2F%2Fwww.deezer.com%2Fchannels%2Fgames%3Fbypassreferer%3D1&amv=8.0.12&imv=10.12.0"
					tracking={{
						eventaction: 'discover-channel-game',
						eventlabel: 'section3',
					}}
					fontSize={fontSize}
				>
					{t('generic_action_gogogo_standalone-web', {ns: 'common'})}
				</LandingButtonLink>
			}
		/>
	);
};
